import { jsonApi } from '../http-request';

export const actions = jsonApi.createUpdResourceFacade('bulk');

const ITEMS = 'items';
actions.items = items => actions.action(ITEMS, items);
actions.isItems = actions.isAction(ITEMS);
